import React from 'react';
export default function Home({match}) {
    return <h1>Page Not Found</h1>;
}